import { useI18n } from 'vue-i18n';
/**
 * Composable for parsing backend response exceptions into localized error messages.
 */
export function useResponseExceptionParser() {
    const { t } = useI18n();
    function parseResponseException(response) {
        if (response === null || response === undefined) {
            return t('common.dataGrid.postError');
        }
        let data = response;
        if (typeof response === 'string') {
            try {
                data = JSON.parse(response);
            }
            catch {
                // Not a valid JSON string; return as is
                return response;
            }
        }
        const formatItem = (item) => {
            if (typeof item === 'string') {
                return item;
            }
            if (item && typeof item === 'object') {
                const code = item.code ?? item.ErrorCode ?? item.state ?? item.State;
                const params = item.additionalInfo ?? item.AdditionalInfo;
                if (code) {
                    return params ? t(`errors.datagrid.${code}`, params) : t(`errors.datagrid.${code}`);
                }
                if (item.message ?? item.Message) {
                    return item.message ?? item.Message;
                }
            }
            return String(item ?? '');
        };
        if (Array.isArray(data)) {
            return data.map(formatItem).join('\n');
        }
        if (data && typeof data === 'object') {
            return formatItem(data);
        }
        return String(data);
    }
    return {
        parseResponseException,
    };
}
